import Vue from 'vue';
import googleApiLoader from '../../utils/googleAPI';

import {
  GOOGLE_INIT,
  GOOGLE_INIT_GEOCODER,
} from '../mutations-types'

const state = {
  googleObject: null,
  googleGeocoder: null
};

const getters = {
  googleObject: state => state.googleObject,
};

const mutations = {
  [GOOGLE_INIT](state, obj) {
    Vue.set(state, 'googleObject', obj);
  },

  [GOOGLE_INIT_GEOCODER](state) {
    Vue.set(state, 'googleGeocoder', (new state.googleObject.maps.Geocoder()));
  },
};


const actions = {
  /**
   * @note
   * js API request
   * @Params
   * fullAddress: string, required
   * **/
  GOOGLE_GEOCODING_REQUEST_GET ({ state, commit }, fullAddress) {
    let googleFullAddress = fullAddress.replace(/\s/g, '+');
    return new Promise((resolve, reject) => {

      if (state.googleObject !== null) {

        if (state.googleGeocoder == null) {
          commit(GOOGLE_INIT_GEOCODER);
        }

        state.googleGeocoder.geocode( { 'address': googleFullAddress}, function(results, status) {
          if (status === 'OK') {
            resolve(results);
          } else {
            reject({results,status});
          }
        });
      } else {
        googleApiLoader().then(result => {
          if (state.googleObject == null) {
            commit(GOOGLE_INIT,result);
          }

          if (state.googleGeocoder == null) {
            commit(GOOGLE_INIT_GEOCODER);
          }

          state.googleGeocoder.geocode({ 'address': googleFullAddress}, function(results, status) {
            if (status === 'OK') {
              resolve(results);
            } else {
              reject({results,status});
            }
          });
        });
      }
    });
  },

  /**
   * @note
   * js API request
   * @Params
   * none
   * **/
  GOOGLE_INIT_REQUEST_GET ({ state, commit }) {
    return new Promise((resolve, reject) => {
      if (state.googleObject !== null) {
          resolve(state.googleObject);
      } else {
        googleApiLoader().then(result => {
          if (state.googleObject == null) {
            commit(GOOGLE_INIT,result);
          }
          resolve(state.googleObject);
        });
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
